customElements.define('telesin-article', class extends HTMLElement {
    constructor() {
        super();
        this.isMobile = false;
        this.scrollOffest = 20;
    }
    connectedCallback() {
        const article = this.querySelector('.article-content-container').innerHTML;
        // this.articleDom = new DOMParser().parseFromString(article, 'text/html');
        this.articleDom = new DOMParser().parseFromString(article, 'text/html');
        this.h2Tags = this.articleDom.querySelectorAll('h2');
        this.contentContainer = this.querySelector('.article-content-container');
        this.navContainer = this.querySelector('.article-nav-container');
        this.navList = this.querySelector('.article-nav-list');
        this.navTitle = this.querySelector('.article-nav-title');
        this.overlay = this.querySelector('.article-overlay');
        const header = document.querySelector(".header-v2--legacy");
        this.headerHeight = header ? header.getBoundingClientRect().height : 0;
        this.navTitleHeight = this.navTitle.getBoundingClientRect().height;
        this.init();
        this.bindEvents();
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.scrollHandler);
        if (this.rafId !== null) {
            cancelAnimationFrame(this.rafId);
        }
    }
    init() {
        this.renderNav();
        this.renderContent();
        this.checkMobile();
        window.addEventListener('resize', () => this.checkMobile());
    }
    checkMobile() {
        this.isMobile = window.innerWidth < 768;
    }
    bindEvents() {
        this.navList.addEventListener('click', this.handleNavClick.bind(this));
        this.navTitle.addEventListener('click', this.handleNavTitleClick.bind(this));
        this.overlay.addEventListener('click', this.handleOverlayClick.bind(this));
        // 使用 requestAnimationFrame 实现流畅的滚动检测
        this.rafId = null;
        this.currentActiveIndex = -1;
        this.scrollHandler = this.handleScroll.bind(this);
        window.addEventListener('scroll', () => {
            // 如果已经有待执行的 requestAnimationFrame，取消它
            if (this.rafId !== null) {
                cancelAnimationFrame(this.rafId);
            }
            // 使用 requestAnimationFrame 确保在下一帧执行，实现流畅更新
            this.rafId = requestAnimationFrame(() => {
                this.scrollHandler();
                this.rafId = null;
            });
        });
        // 初始化时也执行一次，设置初始 active 状态
        this.handleScroll();
    }
    handleNavTitleClick(e) {
        if (this.isMobile) {    
            e.preventDefault();
            const scrollTop = this.getTargetScrollPosition(this.navTitle) + this.scrollOffest + this.navTitleHeight;
            window.scrollTo({top: scrollTop, behavior: 'smooth'});
            this.navList.classList.toggle('tw-hidden');
            this.navList.classList.toggle('tw-flex');
            this.overlay.classList.toggle('tw-hidden');
            const navTitleIcon = this.navTitle.querySelector('svg');
            navTitleIcon.style.transform = this.navList.classList.contains('tw-hidden') ? 'rotate(0deg)' : 'rotate(180deg)';
        }
    }
    handleOverlayClick(e) {
        if (this.isMobile) {
            e.preventDefault();
            this.navList.classList.add('tw-hidden');
            this.navList.classList.remove('tw-flex');
            this.overlay.classList.add('tw-hidden');
            this.overlay.classList.remove('tw-block');
            const navTitleIcon = this.navTitle.querySelector('svg');
            navTitleIcon.style.transform = 'rotate(0deg)';
        }
    }
    renderNav() {
        this.navList.innerHTML = '';
        this.h2Tags.forEach((h2, index) => {
            const h2Text = h2.textContent;
            const h2Id = `anchor-point-${index}`;
            // h2.id = h2Id;
            const a = document.createElement('a');
            a.href = `#${h2Id}`;
            a.textContent = h2Text;
            a.classList.add('article-nav-link');
            this.navList.appendChild(a);
        });
    }
    renderContent() {
        this.contentContainer.innerHTML = '';
        // this.contentContainer.innerHTML = this.articleDom.body.innerHTML;
        this.h2Tags.forEach((h2, index) => {
            //给h2标签添加id
            const h2Id = `anchor-point-${index}`;
            h2.id = h2Id;
        });
        this.contentContainer.innerHTML = this.articleDom.body.innerHTML;
    }
    // 获取目标滚动位置（和点击时使用相同的计算方式）
    getTargetScrollPosition(h2Element) {
        // const header = document.querySelector(".shopify-section-group-header-group");
        // const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const contentRect = h2Element.getBoundingClientRect();
        const contentTop = contentRect.top + window.pageYOffset;
        // return contentTop - this.headerHeight - this.scrollOffest;
        return this.isMobile ? contentTop - this.headerHeight - this.navTitleHeight - this.scrollOffest : contentTop - this.headerHeight - this.scrollOffest;
    }

    // 点击导航栏滚动到对应内容
    handleNavClick(e) {
        e.preventDefault();
        const target = e.target;
        const id = target.href.split('#')[1];
        const content = document.getElementById(id);
        if (content) {
            const scrollTo = this.getTargetScrollPosition(content);
            window.scrollTo({
                top: scrollTo,
                behavior: 'smooth'
            });
        }
    }

    handleScroll(e) {
        // 获取 header 高度
        // const header = document.querySelector(".shopify-section-group-header-group");
        // const headerHeight = header ? header.getBoundingClientRect().height : 0;

        // 获取所有导航链接和对应的 h2 元素
        const navLinks = Array.from(this.navList.querySelectorAll('a'));
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let activeIndex = -1;

        // 遍历所有 h2 元素，找到当前应该激活的项
        // 使用和点击时相同的计算方式：contentTop - headerHeight - 20
        for (let i = 0; i < this.h2Tags.length; i++) {
            const h2Id = `anchor-point-${i}`;
            const h2Element = document.getElementById(h2Id);

            if (!h2Element) continue;

            // 计算该 h2 的目标滚动位置（和点击时完全一致）
            const targetScrollTop = this.getTargetScrollPosition(h2Element);

            // 如果当前滚动位置已经到达或超过这个位置，说明应该激活这个项
            if (currentScrollTop >= targetScrollTop - 5) { // 允许5px的误差
                activeIndex = i;
            } else {
                // 如果当前 h2 还没滚动到目标位置，停止查找
                break;
            }
        }

        // 如果没找到，默认激活第一项
        if (activeIndex < 0 && navLinks.length > 0) {
            activeIndex = 0;
        }

        // 只在 active 状态改变时才更新 DOM，提高性能
        if (activeIndex !== this.currentActiveIndex) {
            this.currentActiveIndex = activeIndex;
            navLinks.forEach((link, index) => {
                if (index === activeIndex) {
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            });
        }
    }
});